import * as React from "react";
import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";
import { IGiftAndDonation } from "../../../../model/report/applicantdata/GiftAndDonation";
import NumberFormatter from "../../../../model/common/NumberFormatter";
import SagoeUi from "../../../assets/fonts/623c7118249e082fe87a78e08506cb4b.ttf";
import SagoeUiItalic from "../../../assets/fonts/a1f05a6515e69ab2886bdaaf1489d410.ttf";
import SagoeUiBold from "../../../assets/fonts/60570a3f64a1fece44ebf71b43617029.ttf";

const PDFExportGiftAndDonation = ({
  translate,
  data
}: {
  translate?: any;
  data?: IGiftAndDonation[];
  title?: string;
  subtitle?: string;
}) => {
  return (
    <View>
      <View style={styles.titleCol}>
        <Text style={styles.header}>
          {translate("report8.document_template.gifts_and_donations.title")}
        </Text>
      </View>

      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.gifts_and_donations.recipient_name"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.gifts_and_donations.giver_name"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.gifts_and_donations.gift_type"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.gifts_and_donations.description"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={{ ...styles.tableCell, textAlign: "right" }}>
              {translate("report8.document_template.gifts_and_donations.value")}
            </Text>
          </View>
          <View style={styles.tableDateCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.gifts_and_donations.recieving_date"
              )}
            </Text>
          </View>
        </View>
        {data?.map((item, index) => (
          <View style={styles.tableRow} key={index}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.recipientName}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.giverName}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.giftType}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.description} </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={{ ...styles.tableCell, textAlign: "right" }}>
                {NumberFormatter().formatReadOnlyValue(item.value)}
              </Text>
            </View>
            <View style={styles.tableDateCol}>
              <Text style={styles.tableCell}>{item.receivingDate}</Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default PDFExportGiftAndDonation;

Font.register({
  family: "Segoe UI",
  fonts: [
    {
      src: SagoeUiBold,
      fontWeight: "bold"
    },
    {
      src: SagoeUiItalic,
      fontStyle: "italic"
    },
    { src: SagoeUi }
  ]
});

const styles = StyleSheet.create({
  body: {
    padding: 20
  },
  titleCol: {
    display: "flex",
    flexDirection: "column"
  },
  title: {
    fontSize: "14pt",
    height: "20pt",
    padding: "0pt 5pt 0pt 5pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  subtitle: {
    fontSize: "10pt",
    padding: "0pt 5pt 0pt",
    fontFamily: "Segoe UI"
  },
  header: {
    fontSize: "12pt",
    padding: "0pt 5pt 0pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    marginBottom: 20,
    marginLeft: 5
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableCol: {
    width: "17.6%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0
  },
  tableDateCol: {
    width: "12%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0
  },
  tableCell: {
    margin: "auto",
    marginLeft: 5,
    fontSize: 10,
    fontFamily: "Segoe UI"
  },
  previewTable: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    flexDirection: "column"
  },
  previewRow: {
    margin: "auto",
    flexDirection: "row",
    width: "100%",
    display: "flex"
  }
});
